import { Pipe, PipeTransform } from '@angular/core';
import { FileSizePipe, UploadFileStateRecord } from '@aiwyn/shared';

@Pipe({
  name: 'fileUploadedProgress',
  pure: true,
  standalone: true,
})
export class FileUploadedProgressPipe implements PipeTransform {
  transform(file: Pick<UploadFileStateRecord, 'bytesLoaded' | 'bytesTotal'>): string {
    if (!file.bytesTotal) {
      return '';
    }
    if (file.bytesLoaded === file.bytesTotal) {
      return FileSizePipe.staticTransform(file.bytesTotal, 1);
    }
    return FileSizePipe.staticTransform(file.bytesLoaded, 1, true) + ' / ' + FileSizePipe.staticTransform(file.bytesTotal, 1);
  }
}
